import React from 'react';
import { MarkPropTypes } from './PropTypes.es6';

export default function(Tag, tagProps = {}) {
  const CommonMark = ({ attributes, children }) => {
    return (
      <Tag {...tagProps} {...attributes}>
        {children}
      </Tag>
    );
  };

  CommonMark.displayName = `${Tag}-mark`;
  CommonMark.propTypes = MarkPropTypes;

  return CommonMark;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/plugins/shared/MarkDecorator.es6.js